import { getEmisoresList } from 'services/emisores'
import { selectActiveWorkspace } from 'lib/helpers/selectors'
import { FC, useEffect, useState } from 'react'
import { useAppSelector } from 'store/hooks'

const TaxResidenceLabel: FC = () => {
  const workspaceId = useAppSelector(selectActiveWorkspace)
  const [label, setLabel] = useState<string>()
  useEffect(() => {
    if (workspaceId) {
      setLabel('...')
      getEmisoresList(workspaceId)
        .then(data => {
          const rfc = data[0]
          if (rfc) {
            setLabel(rfc.taxResidence.label)
          } else {
            setLabel('No hay RFCs')
          }
        })
        .catch(error => {
          setLabel('')
        })
    }
  }, [workspaceId])

  if (!workspaceId) return null

  return (
    <div>
      <b>Régimen fiscal:</b> {label}
    </div>
  )
}

export default TaxResidenceLabel
